module.exports = __webpack_public_path__ + "static/media/illustration-horseback-riding.19ee0879.png";